import { Link } from 'react-router-dom';
import { KC_COLORS } from '../theme';
import { KcIcon } from './KcIcon';

export function CategoryTopicRow({ topic }) {
  return (
    <Link
      id={topic.anchorId}
      to={topic.path}
      className="kc-category-topic group grid grid-cols-[auto_minmax(0,1fr)_auto] items-start md:items-center gap-x-4 md:gap-x-5 px-4 md:px-5 py-4 md:py-5 mb-2.5 last:mb-0 rounded-xl border bg-white transition-all duration-200 ease-out scroll-mt-28"
      style={{ borderColor: KC_COLORS.border }}
    >
      <span
        className="inline-flex shrink-0 items-center justify-center w-11 h-11 md:w-12 md:h-12 rounded-xl transition-transform duration-300 group-hover:scale-105"
        style={{ backgroundColor: KC_COLORS.tealLight, color: KC_COLORS.teal }}
      >
        <KcIcon
          name={topic.icon}
          fontSize="medium"
          sx={{ fontSize: { xs: 22, md: 24 } }}
        />
      </span>

      <div className="min-w-0 text-left">
        <h3
          className="kc-type-h3 transition-colors duration-200"
          style={{ color: KC_COLORS.primaryNavy, fontSize: '18px', lineHeight: '26px' }}
        >
          {topic.title}
        </h3>
        <p
          className="mt-1.5 kc-type-body line-clamp-2"
          style={{ color: KC_COLORS.gray600 }}
        >
          {topic.description}
        </p>
      </div>

      <div className="shrink-0 text-right pl-2 pt-1 md:pt-0">
        <span
          className="block kc-type-caption font-semibold leading-tight whitespace-nowrap"
          style={{ color: KC_COLORS.teal, fontWeight: 700 }}
        >
          {topic.articleCountLabel}
        </span>
      </div>
    </Link>
  );
}
